import { ChangeEvent, ChangeEventHandler, forwardRef, useState } from "react";
import IconSprite from "@/components/UI/IconSprite";
import st from "./index.module.scss";

type SwitcherPropsType = {
  label?: string;
  name?: string;
  className?: string;
  defaultChecked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  style?: React.CSSProperties;
  title?: string;
  tabIndex?: number;
  id?: string;
  checked?: boolean;
  value?: string;
};
export const Switcher = forwardRef<HTMLInputElement, SwitcherPropsType>((props, ref) => {
  const {
    label,
    name = "switch",
    id = "checkbox-on-off",
    className,
    disabled,
    checked,
    onChange,
    ...rest
  } = props;

  const checkedValue = typeof checked === "boolean" ? String(checked) : rest?.value;

  const [currentValue, setCurrentValue] = useState(checkedValue);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(String(e.target.checked));
    onChange?.(e);
  };
  return (
    <div className={`${st["checkbox-on-off"]} ${className ? className : ""}`}>
      <label htmlFor={id} className={st["checkbox-on-off__label"]}>
        {label && <div className={st["checkbox-on-off__label-text"]}>{label}</div>}
        <div className={st["checkbox-on-off__ch-wr"]}>
          <input
            {...rest}
            type="checkbox"
            id={id}
            name={name}
            checked={checked}
            disabled={disabled}
            value={currentValue}
            onChange={handleChange}
            ref={ref}
            className={st["checkbox-on-off__ch"]}
          />
          <div className={st["checkbox-on-off__pseudo-block"]}>
            <div className={st["checkbox-on-off__pseudo-block-ic-wr"]}>
              <IconSprite name="check" className={st["icon checkbox-on-off__pseudo-block-ic"]} />
            </div>
          </div>
        </div>
      </label>
    </div>
  );
});

Switcher.displayName = "Switcher";
